import { useTheme } from '@mui/material/styles';
import { styleConstants } from '../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        basicLogin: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(3),
            paddingBottom: theme.spacing(4),
        },
        card: {
            [theme.breakpoints.up('md')]: {
                border: `1px solid ${theme.palette.grey[200]}`,
            },
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.primary.main,
            borderRadius: styleConstants.borderRadius,
        },
        logotype: {
            display: 'flex',
            justifyContent: 'center',
            '& > img': {
                height: '12rem',
                width: '12rem',
            },
        },
        accountIcon: {
            height: '6rem !important',
            width: '6rem !important',
        },
        iconContainer: {
            width: '12rem',
            height: '12rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        validation: {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            display: 'flex',
            padding: theme.spacing(1.5),
        },
        validationIcon: {
            marginRight: theme.spacing(1),
        },
    };
};
